function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#2C3341;}\n\t.st1{fill:#4C84FF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Asset 1");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2_1_"
}, React.createElement("g", {
  id: "Layer1"
}, React.createElement("path", {
  className: "st0",
  d: "M230,43.1c7.9,0,16.3,2.6,22.1,8.3l-6.7,10.9c-3.8-3.3-9.5-6-14.7-6c-11.8,0-16.6,8.3-16.6,16.8 c0,8.7,5.3,17.7,16.6,17.7c5.8,0,11.6-3.2,15.6-7.2l7.4,10.5c-0.8,0.8-1.6,1.6-2.5,2.4c-5.9,5-13.5,7.6-21.2,7.5 c-18.9,0-30.9-13.1-30.9-30.5S211.8,43.1,230,43.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M285.7,43.1c18.3,0,30.8,13.2,30.8,30c0,17.3-12.5,30.8-30.8,30.8s-30.8-13.5-30.8-30.8 C255,56.2,267.5,43.1,285.7,43.1z M285.7,90.7c9.3,0,15.9-7.6,15.9-17.6c0-9.6-6.6-16.9-15.9-16.9s-15.9,7.2-15.9,16.9 C269.9,83.2,276.4,90.7,285.7,90.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M325.1,44.1H340L355.8,72c1.8,3.3,3.4,6.7,4.8,10.1h0.2c0,0-0.7-6.4-0.7-10.1V44.1h14v59h-14.4L343.5,76 c-1.8-3.2-3.4-6.5-4.9-9.9h-0.2c0,0,0.7,6.2,0.7,9.9v27.1h-14V44.1L325.1,44.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M401.1,56.1h-18v-12h50v12h-18v47h-14V56.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M451.4,44.1h15.2l20.1,59h-15.2l-3.5-12h-17.9l-3.4,12h-15.2L451.4,44.1z M464.8,79.1l-3.4-11.7 c-1.1-3.8-2.5-10.3-2.5-10.3h-0.2c0,0-1.3,6.5-2.5,10.3l-3.5,11.7H464.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M519.6,43.1c7.9,0,16.3,2.6,22.1,8.3L535,62.3c-3.8-3.3-9.5-6-14.7-6c-11.8,0-16.6,8.3-16.6,16.8 c0,8.7,5.3,17.7,16.6,17.7c5.8,0,11.6-3.2,15.6-7.2l7.4,10.5c-6.2,6.4-14.8,10-23.7,9.9c-18.9,0-30.9-13.1-30.9-30.5 S501.4,43.1,519.6,43.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M568.1,56.1h-18v-12h50v12h-18v47h-14V56.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M146.7,53.1c-1.4-5.8-7.3-9.4-13.1-8c-5.8,1.4-9.4,7.3-8,13.1c0,0.2,0.1,0.3,0.1,0.5 c7.6,28.2-9.2,57.2-37.4,64.8c-4.5,1.2-9,1.8-13.7,1.8c-2.7,0-5.4-0.2-8.1-0.6c14.9-3.4,24.2-18.2,20.8-33s-18.2-24.2-33-20.8 c-12.6,2.9-21.5,14-21.5,26.9c0,2.9,0.5,5.7,1.3,8.5c-18.7-22.4-15.7-55.6,6.6-74.3c5.9-5,12.9-8.6,20.4-10.6 c5.8-1.5,9.2-7.4,7.7-13.2c0,0,0-0.1,0-0.1c-1.5-5.8-7.4-9.2-13.2-7.7c0,0-0.1,0-0.1,0C15.8,11.1-7.7,51.9,3,91.5 s51.5,63.2,91.1,52.5C133.7,133.4,157.2,92.7,146.7,53.1z"
}), React.createElement("circle", {
  className: "st1",
  cx: 103.3,
  cy: 23.3,
  r: 18
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600.1 147.2",
    style: {
      enableBackground: "new 0 0 600.1 147.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.82a7c062.svg";
export { ForwardRef as ReactComponent };